var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ref, onValue, runTransaction, get, query, orderByChild, limitToLast, } from 'firebase/database';
import { ref as storageRef, uploadBytes, getDownloadURL, deleteObject, listAll, } from 'firebase/storage';
import mixpanel from '../../config/mixpanelConfig';
import { httpsCallable } from 'firebase/functions';
import { displayToast } from '../../components/Toast';
import { database, storage, functions } from '../../config/firebaseConfig';
import generatePushID from '../../../../shared/utils/generate-pushid';
import { detachExtensionFromFilename } from '../../scripts/filenameHandler';
var _createCollection = httpsCallable(functions, 'addCollection');
export var createCollection = function (collectionName) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var _a;
                    var workspaceId = getState().workspace.id;
                    var collectionId = "col".concat(generatePushID());
                    var initialSectionId = "sec".concat(generatePushID());
                    var currentDate = new Date().toISOString();
                    var newCollection = {
                        name: collectionName,
                        id: collectionId,
                        dateCreated: currentDate,
                        lastModified: currentDate,
                        workspaceId: workspaceId,
                        sectionOrder: [initialSectionId],
                        sections: (_a = {},
                            _a[initialSectionId] = {
                                name: 'untitled section',
                                id: initialSectionId,
                                dateCreated: currentDate,
                                lastModified: currentDate,
                            },
                            _a),
                    };
                    dispatch({
                        type: 'collection/create/pending',
                        payload: newCollection,
                    });
                    return _createCollection({ collection: newCollection })
                        .then(function () {
                        mixpanel.track('create collection');
                        dispatch({
                            type: 'collection/create/fulfilled',
                            payload: newCollection,
                        });
                        resolve(newCollection);
                    })
                        .catch(function (err) {
                        console.log(err);
                        displayToast('error', 'An error occurred, please try again.');
                        dispatch({
                            type: 'collection/create/rejected',
                            payload: newCollection,
                        });
                        reject();
                    });
                })];
        });
    }); };
};
export var unsubscribeCollectionListener = function () { };
/**
 * When called, this action creator fetches the Collection from Firebase
 * but it's also responsible to update the Redux state if any change occurs
 * (e.g. another user makes a change to the Collection).
 * @param collectionId The ID of the collection to load
 */
export var loadCollectionAndListenForEvents = function (collectionId) {
    return function (dispatch) {
        return new Promise(function (resolve, reject) {
            dispatch({ type: 'collection/load/pending' });
            unsubscribeCollectionListener();
            unsubscribeCollectionListener = onValue(ref(database, "collections/".concat(collectionId)), function (snapshot) {
                var collection = snapshot.val();
                dispatch({ type: 'collection/load/fulfilled', payload: collection });
                resolve(collection);
            }, function (err) {
                console.log(err);
                dispatch({ type: 'collection/load/rejected' });
                reject();
            });
        });
    };
};
export var loadDiscoverCollection = createAsyncThunk('collection/load', function () { return __awaiter(void 0, void 0, void 0, function () {
    var getLastImages, _a, images, order;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                unsubscribeCollectionListener();
                getLastImages = query(ref(database, 'collections/col-product-design/images'), orderByChild('dateCreated'), limitToLast(20));
                return [4 /*yield*/, get(getLastImages)
                        .then(function (snapshot) {
                        var order = [];
                        snapshot.forEach(function (child) {
                            order.unshift(child.key);
                        });
                        return { images: snapshot.val(), order: order };
                    })
                        .catch(function (err) {
                        // somehow Firebase doesn't display an error automatically
                        // without this catch block.
                        console.log(err);
                        throw new Error(err);
                    })
                    // create a pseudo collection
                ];
            case 1:
                _a = _b.sent(), images = _a.images, order = _a.order;
                // create a pseudo collection
                return [2 /*return*/, {
                        images: images,
                        id: 'discover-collection',
                        sections: {
                            section_0: {
                                id: 'section_0',
                                imageOrder: order,
                            },
                        },
                        sectionOrder: ['section_0'],
                    }];
        }
    });
}); });
var _renameCollection = httpsCallable(functions, 'renameCollection');
export var renameCollection = createAsyncThunk('collection/rename', function (newName, _a) {
    var getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, collection, workspace, updatedCollection;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _b = getState(), collection = _b.collection, workspace = _b.workspace;
                    return [4 /*yield*/, _renameCollection({
                            workspaceId: workspace.id,
                            collectionId: collection.id,
                            newName: newName,
                        })];
                case 1:
                    updatedCollection = _c.sent();
                    mixpanel.track('rename collection');
                    return [2 /*return*/, updatedCollection];
            }
        });
    });
});
export var changeCollectionPublicSetting = createAsyncThunk('collection/updatePublicSetting', function (value, _a) {
    var getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var collection, updatedCollection;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    collection = getState().collection;
                    return [4 /*yield*/, _patchCollection(collection, {
                            isPublic: value,
                        })];
                case 1:
                    updatedCollection = _b.sent();
                    value === true
                        ? mixpanel.track('make collection public')
                        : mixpanel.track('make collection private');
                    return [2 /*return*/, updatedCollection];
            }
        });
    });
});
var _patchCollection = function (collection, propertiesToUpdate) {
    return new Promise(function (resolve, reject) {
        var updatedCollection = __assign(__assign({}, collection), propertiesToUpdate);
        runTransaction(ref(database, "collections/".concat(collection.id)), function (collection) {
            if (collection) {
                return __assign(__assign({}, collection), propertiesToUpdate);
            }
        })
            .then(function () { return resolve(updatedCollection); })
            .catch(function (err) {
            console.log(err);
            reject();
        });
    });
};
var _deleteCollection = httpsCallable(functions, 'deleteCollection');
export var deleteCollection = createAsyncThunk('collection/delete', function (collectionId, _a) {
    var getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var workspaceId;
        return __generator(this, function (_b) {
            // detatch event listener from Firebase
            unsubscribeCollectionListener();
            workspaceId = getState().workspace.id;
            return [2 /*return*/, _deleteCollection({ collectionId: collectionId, workspaceId: workspaceId })
                    .then(function (result) {
                    mixpanel.track('delete collection');
                    return result.data;
                })
                    .catch(function (err) {
                    console.log(err);
                    displayToast('error', 'An error occurred, please try again.');
                })];
        });
    });
});
var _addSection = httpsCallable(functions, 'addSection');
export var createSection = function (sectionName) {
    if (sectionName === void 0) { sectionName = 'untitled section'; }
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var collectionId, sectionId, currentDate, newSection;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    collectionId = getState().collection.id;
                    sectionId = "sec".concat(generatePushID());
                    currentDate = new Date().toISOString();
                    newSection = {
                        name: sectionName,
                        id: sectionId,
                        dateCreated: currentDate,
                        lastModified: currentDate,
                    };
                    dispatch({
                        type: 'section/create/pending',
                        payload: newSection,
                    });
                    return [4 /*yield*/, _addSection({ collectionId: collectionId, section: newSection })
                            .then(function () {
                            mixpanel.track('create section');
                            dispatch({
                                type: 'section/create/fulfilled',
                                payload: newSection,
                            });
                        })
                            .catch(function (err) {
                            console.log(err);
                            displayToast('error', 'An error occurred, please try again.');
                            dispatch({
                                type: 'section/create/rejected',
                                payload: newSection,
                            });
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
};
export var renameSection = function (sectionId, newName) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var collection, updatedSection;
        return __generator(this, function (_a) {
            collection = getState().collection;
            updatedSection = __assign(__assign({}, collection.sections[sectionId]), { name: newName });
            dispatch({
                type: 'section/rename',
                payload: {
                    updatedSection: updatedSection,
                },
            });
            mixpanel.track('rename section');
            runTransaction(ref(database, "collections/".concat(collection.id, "/sections/").concat(sectionId)), function (section) {
                if (section) {
                    section.name = newName;
                }
                return section;
            }).catch(function (err) { return console.log(err); });
            return [2 /*return*/];
        });
    }); };
};
var _deleteSection = httpsCallable(functions, 'deleteSection');
export var deleteSection = function (sectionId) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var collectionId;
        return __generator(this, function (_a) {
            collectionId = getState().collection.id;
            dispatch({
                type: 'section/delete/pending',
                payload: { sectionId: sectionId },
            });
            return [2 /*return*/, _deleteSection({ collectionId: collectionId, sectionId: sectionId })
                    .then(function () {
                    mixpanel.track('delete section');
                    dispatch({
                        type: 'section/delete/fulfilled',
                    });
                })
                    .catch(function (err) {
                    console.log(err);
                    displayToast('error', 'An error occurred, please try again.');
                    dispatch({
                        type: 'section/delete/rejected',
                        payload: { sectionId: sectionId },
                    });
                })];
        });
    }); };
};
export var uploadImage = function (fileList, sectionId, collectionId) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, blocks, storageAmount, uploadProcessSize, collectionObject, imageOrder, uploadProcess;
        var _b, _c;
        return __generator(this, function (_d) {
            _a = getState().workspace._admin, blocks = _a.blocks, storageAmount = _a.storageAmount;
            uploadProcessSize = fileList.reduce(function (partialSum, currentFile) { return partialSum + currentFile.size; }, 0);
            if (blocks + Object.values(fileList).length > 500 ||
                storageAmount + uploadProcessSize > 161061273600) {
                displayToast('error', 'Space exceeded. Please upgrade to continue using Substratum.', false);
                return [2 /*return*/];
            }
            // get the current collection and estract the image array where to upload
            if (collectionId) {
                if (collectionId !== ((_b = getState().collection) === null || _b === void 0 ? void 0 : _b.id)) {
                    dispatch(loadCollectionAndListenForEvents(collectionId));
                }
            }
            else {
                collectionId = getState().collection.id;
            }
            collectionObject = getState().collection;
            // define the section to upload images into and their details
            sectionId = sectionId || Object.values(collectionObject.sections)[0].id;
            imageOrder = (collectionObject.sections[sectionId].imageOrder || []).map(function (id) { return id; });
            // initialize the upload process with Firebase database and Electron
            // onDisconnect(
            // 	ref(database, `collections/${collectionObject.id}/uploadInterrupted`)
            // ).set(true)
            (_c = window.electron) === null || _c === void 0 ? void 0 : _c.send('client/startUploadProcess');
            uploadProcess = fileList.map(function (imageFile) {
                return new Promise(function (resolve, reject) {
                    // 1. create a proto image object for each file as a reference
                    var imageId = "img".concat(generatePushID());
                    var currentDate = new Date().toISOString();
                    var filenameObject = detachExtensionFromFilename(imageFile.name);
                    var imagePlaceholder = {
                        isPlaceholder: true,
                        name: filenameObject.filename,
                        id: imageId,
                        version: "v-".concat(generatePushID()),
                        dateCreated: currentDate,
                        lastModified: currentDate,
                    };
                    // 2. adds the placeholder images to the collection
                    dispatch({
                        type: 'image/upload/pending',
                        payload: {
                            imagePlaceholder: imagePlaceholder,
                            sectionId: sectionId,
                        },
                    });
                    // 3. upload the images to firebase storage and return the url,
                    // then take the url and assign it to the imageObject
                    return _uploadImageToStorage(imageFile, imagePlaceholder, collectionObject.workspaceId)
                        .then(function (image) {
                        // update the imageOrder in the section (this is needed in
                        // order to sync with Firebase once the image is succ. uploaded)
                        imageOrder = __spreadArray(__spreadArray([], imageOrder, true), [image.id], false);
                        // add the final image to the collection
                        dispatch({
                            type: 'image/upload/fulfilled',
                            payload: image,
                        });
                        resolve(image);
                    })
                        .catch(function () {
                        dispatch({
                            type: 'image/upload/rejected',
                            payload: {
                                imageId: imageId,
                                sectionId: sectionId,
                            },
                        });
                        if (imageFile.size > 50000000) {
                            displayToast('error', 'File too large - upgrade to disable file size limits.', false);
                        }
                        else {
                            displayToast('error', 'An error occurred.');
                        }
                        reject();
                    });
                });
            });
            // This gets called once all images have been resolved (uploaded or rejected)
            Promise.allSettled(uploadProcess).then(function (results) {
                var _a;
                var imagesToUpload = results.flatMap(function (result) {
                    return result.status === 'fulfilled' ? result.value : [];
                });
                if (imagesToUpload.length) {
                    var collectionRef = ref(database, "collections/".concat(collectionId));
                    runTransaction(collectionRef, function (collection) {
                        if (!collection ||
                            !collection.sections ||
                            !sectionId ||
                            !collection.sections[sectionId]) {
                            return;
                        }
                        // add images
                        collection.images = imagesToUpload.reduce(function (acc, image) {
                            var _a;
                            return (__assign(__assign({}, acc), (_a = {}, _a[image.id] = image, _a)));
                        }, collection.images || {});
                        // add reference
                        collection.sections[sectionId].imageOrder = __spreadArray(__spreadArray([], (collection.sections[sectionId].imageOrder || []), true), imagesToUpload.map(function (_a) {
                            var id = _a.id;
                            return id;
                        }), true);
                        return collection;
                    }).catch(function (err) {
                        displayToast('error', 'An error occurred.');
                        console.log(err);
                    });
                }
                (_a = window.electron) === null || _a === void 0 ? void 0 : _a.send('client/closeUploadProcess');
                mixpanel.track('upload file', {
                    numberOfFiles: fileList.length,
                });
            });
            return [2 /*return*/];
        });
    }); };
};
// TODO - this could be refactored
export var renameImage = function (imageId, newName) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var collection, updatedImage;
        return __generator(this, function (_a) {
            collection = getState().collection;
            updatedImage = __assign(__assign({}, collection.images[imageId]), { name: newName });
            dispatch({
                type: 'image/rename',
                payload: {
                    updatedImage: updatedImage,
                },
            });
            mixpanel.track('rename image');
            runTransaction(ref(database, "collections/".concat(collection.id, "/images/").concat(imageId, "/name")), function (imageName) {
                imageName && (imageName = newName);
                return imageName;
            }).catch(function (err) { return console.log(err); });
            return [2 /*return*/];
        });
    }); };
};
var moveImage = httpsCallable(functions, 'moveImage');
export var fullFillMoveImage = createAsyncThunk('image/move/drop', function (params, _a) {
    var dispatch = _a.dispatch, getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var collectionId;
        return __generator(this, function (_b) {
            collectionId = getState().collection.id;
            return [2 /*return*/, moveImage(params)
                    .then(function (result) {
                    var collection = result.data;
                    mixpanel.track('move file', {
                    // sameSection: params.destination.sectionId && params.origin.sectionId === params.destination.sectionId,
                    });
                    // console.log(collection)
                })
                    .catch(function (error) {
                    console.log(error);
                    dispatch(loadCollectionAndListenForEvents(collectionId));
                    displayToast('error', 'An error occurred. Please try again.');
                })];
        });
    });
});
export var previewMoveImage = function (params) {
    return {
        type: 'image/move/drag',
        payload: params,
    };
};
var _deleteStorageFolder = function (path) {
    var ref = storageRef(storage, path);
    var _deleteStorageFile = function (pathToFile, fileName) {
        var ref = storageRef(storage, "".concat(pathToFile, "/").concat(fileName));
        return deleteObject(ref);
    };
    return listAll(ref)
        .then(function (dir) {
        dir.items.forEach(function (fileRef) {
            return _deleteStorageFile(ref.fullPath, fileRef.name);
        });
        dir.prefixes.forEach(function (folderRef) {
            return _deleteStorageFolder(folderRef.fullPath);
        });
    })
        .catch(function (error) { return console.log(error); });
};
var _deleteImages = httpsCallable(functions, 'deleteImages');
export var deleteImages = function (imageIdArray, sectionId) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var collectionId;
        return __generator(this, function (_a) {
            collectionId = getState().collection.id;
            dispatch({
                type: 'image/delete',
                payload: {
                    imageIdArray: imageIdArray,
                    sectionId: sectionId,
                },
            });
            return [2 /*return*/, _deleteImages({
                    imageIdArray: imageIdArray,
                    collectionId: collectionId,
                    sectionId: sectionId,
                })
                    .then(function (result) {
                    // const collection = result.data
                    return;
                })
                    .catch(function (err) {
                    displayToast('error', 'Something went wrong. Please try again.');
                    console.log(err);
                })];
        });
    }); };
};
// ----------------------------------------
// Action's internal functions
// ----------------------------------------
function _uploadImageToStorage(imageBlob, imagePlaceholder, workspaceId) {
    return new Promise(function (resolve, reject) {
        var imageRef = storageRef(storage, "workspaces/".concat(workspaceId, "/images/").concat(imagePlaceholder.id, "/").concat(imagePlaceholder.version));
        if (process.env.NODE_ENV === 'development')
            setTimeout(reject, 2000);
        uploadBytes(imageRef, imageBlob, {
            customMetadata: {
                workspaceId: workspaceId,
            },
        })
            .then(function (snapshot) {
            return getDownloadURL(imageRef).then(function (url) {
                var isPlaceholder = imagePlaceholder.isPlaceholder, tempImage = __rest(imagePlaceholder, ["isPlaceholder"]);
                var image = __assign(__assign({}, tempImage), { name: imagePlaceholder.name || 'untitled', path: url, contentType: snapshot.metadata.contentType || 'unknown' });
                resolve(image);
            });
        })
            .catch(function (error) {
            console.log(error);
            reject();
        });
    });
}
